import { selectProjectMemberList } from "app/containers/Features/components/MemberSelection/redux/selector";
import { ticketDetailsLocales } from "app/containers/Features/containers/Ticket/locales";
import { formatEffortShorthand } from "app/containers/Features/helper";
import { EffortEstimatedType } from "app/containers/Features/types";
import { TotalEffortType } from "app/types";
import React, { FC, useMemo } from "react";
import { useSelector } from "react-redux";
import SeparateSpace from "../SeparateSpace";
import AssigneeRow from "./AssigneeRow";
import Footer from "./Footer";
import Header from "./Header";

export const AssigneeHistory: FC<{
  totalEffortEstimated?: TotalEffortType;
  effortEstimated?: EffortEstimatedType[];
}> = ({ totalEffortEstimated, effortEstimated }) => {
  // Global States
  const projectMembers = useSelector(selectProjectMemberList);

  // Variables
  const updatedEffortEstimated = useMemo(
    () =>
      effortEstimated
        ?.map((effort) => {
          return {
            ...effort,
            member: projectMembers.find(
              (member) => member._id === effort.memberId,
            ),
          };
        })
        .filter((effort) => effort.effort.hours || effort.effort.minutes) || [],
    [effortEstimated, projectMembers],
  );

  return (
    <div>
      <Header heading={ticketDetailsLocales.assigneeHistory} />

      <div className="max-h-44 overflow-auto bg-gray-200 border-b border-gray-100">
        {updatedEffortEstimated?.length === 0 ? (
          <p className="p-4 text-center">No assignees found</p>
        ) : (
          updatedEffortEstimated?.map((effort) => (
            <AssigneeRow key={effort._id} data={effort} />
          ))
        )}
      </div>
      <SeparateSpace className="bg-gray-400" />
      <Footer
        title={ticketDetailsLocales.totalEffortsEstimated}
        time={formatEffortShorthand(
          totalEffortEstimated?.hours as number,
          totalEffortEstimated?.minutes as number,
        )}
      />
      <SeparateSpace className="bg-gray-400" />
    </div>
  );
};
